module.exports = __webpack_public_path__ + "static/media/banner.1e15a839.jpg";